{
  "projects": "Projects",
  "order_by": "Order by",
  "new_project": "New project",
  "start": "Start adding an image that represents the project",
  "accepted": "Accepted File Types",
  "drag": "Drag and Drop here",
  "or": "or",
  "browse_files": "Browse Files",
  "error_project": "An error has occurred while displaying this project"
}
